import LazyLoad from 'vanilla-lazyload'
import { Splide } from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'


window.lazyLoad = new LazyLoad({
    elements_selector: '[data-src], [data-srcset], [data-bg]'
})


document.querySelector('.js-togglemobilenav').addEventListener('click', (e) => {
    e.target.classList.toggle('is-active')
    document.querySelector('.js-mobilenav').classList.toggle('is-active')
    document.querySelector('body').classList.toggle('is-scroll-lock')
    document.querySelector('body').classList.toggle('is-mobilenav-active')
})


var loc = document.querySelector('.js-location-trigger')
if (loc) {
    loc.addEventListener('click', (e) => {
        document.querySelector('.js-location').classList.toggle('is-active')
    })
}


function UpdateDuration(el, v) {
    var del = el.querySelector('.tutorials__duration')
    var min = Math.max(1, Math.floor(v.duration / 60))
    del.innerHTML = min.toString() + ' min' + (min == 1 ? '' : 's') + ' watch'
}
document.querySelectorAll('.tutorials__card.vid').forEach(el => {
    var v = el.querySelector('video')
    if (v.readyState >= 2) //already loaded enough, just get duration
        UpdateDuration(el, v)
    else                   //otherwise wait for loadedmetadata event
        v.addEventListener('loadedmetadata', () => { UpdateDuration(el, v) })

    el.addEventListener('click', (e) => {
        if (!v.controls) {
            el.querySelector('.tutorials__play').remove()
            v.controls = true
        }
    })
    v.addEventListener('fullscreenchange', (e) => {
        v.classList.toggle('fs')
    })
})

document.querySelectorAll('.mediabox__link.vid').forEach(el => {
    var v = el.querySelector('video')
    el.addEventListener('click', (e) => {
        if (!v.controls) {
            el.querySelector('.mediabox__play').remove()
            v.controls = true
            let title = el.querySelector('.mediabox__title')
            if (title) title.remove()
        }
    })
    v.addEventListener('fullscreenchange', (e) => {
        v.classList.toggle('fs')
    })
})


document.querySelectorAll('.hero__schedule svg').forEach(el => {
    el.addEventListener('click', (e) => {
        let cards = el.parentElement.querySelector('.hero__schedule_cards')
        cards.scrollBy({ left: 200, behavior: 'smooth' })
    })
})

const leavePopup = document.querySelector('.leave-popup')
const leaveGo = leavePopup.querySelector('.btn.go')
const leaveCancel = leavePopup.querySelector('.btn.cancel')
leaveCancel.addEventListener('click', (e) => {
    leavePopup.classList.remove('is-active')
})
leaveGo.addEventListener('click', (e) => {
    leavePopup.classList.remove('is-active')
})

document.querySelectorAll(lls).forEach(el => {
    el.addEventListener('click', (e) => {
        //if (window.localStorage.getItem('lpos') != '1') {
        e.preventDefault()
        leaveGo.href = el.href
        leaveGo.target = el.target
        leavePopup.classList.add('is-active')
        //    window.localStorage.setItem('lpos', '1')
        //}
    })
})

document.querySelectorAll('.footer__partners-items').forEach(el => {
    const sp = new Splide(el, {
        type: 'loop',
        autoplay: true,
        perPage: 1,
        fixedWidth: 240,
        gap: 20,
        arrows: false,
        pagination: false,
        autoScroll: {
            speed: 1,
            pauseOnFocus: false
        }
    }).mount({ AutoScroll });

    const imgs = el.querySelectorAll('img')
    imgs.forEach(i => {
        i.addEventListener('load', () => {
            sp.refresh()
        })
    })

})
